"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CompiledFilter = function CompiledFilter(filter, cache) {
  _classCallCheck(this, CompiledFilter);

  if (filter.categories) {
    var expr = cache.parse(filter.categories.expression);
    var map = filter.categories.values;

    this.filter = function (context) {
      var val = expr.getStringValue(context);
      return map.hasOwnProperty(val) && map[val] == true;
    };
  } else if (filter.expression) {
    var _expr = cache.parse(filter.expression);

    this.filter = function (context) {
      return _expr.getValue(context);
    };
  }
};

exports.CompiledFilter = CompiledFilter;